import PropTypes from 'prop-types'
import React from 'react'
import { injectIntl, FormattedMessage } from 'react-intl'
import { CARD_NAME_MAX_LENGTH } from 'const/limits'
import {
  CardModalView,
  ViewBody
} from 'components/Sidebar'
import withLeftSidebar from 'components/Sidebar/withLeftSidebar'
import CreateTemplateAction from 'components/CardActions/Template'
import HistoryContext from 'components/App/HistoryContext'

export class CreateCard extends React.Component {
  static propTypes = {
    cardId: PropTypes.number.isRequired,

    intl: PropTypes.object.isRequired,
    leftSidebar: PropTypes.object.isRequired,

    name: PropTypes.string.isRequired,
    requestAddCard: PropTypes.func.isRequired,
  }

  static contextType = HistoryContext

  handleValidate = ({ name }) => {
    const { intl } = this.props

    const errors = {}
    if (name && name.length > CARD_NAME_MAX_LENGTH) {
      errors.name = intl.formatMessage({ id: 'CARD_NAME_TOO_LONG' }, { limit: CARD_NAME_MAX_LENGTH })
    }
    return errors
  }

  handleSubmit = ({ name }) => {
    const { cardId, requestAddCard } = this.props

    if (name) {
      requestAddCard({
        cardId,
        template: { type: 'card', id: cardId },
        name,
      }).then(({ id }) => {
        if (id) {
          this.context.push('/card/' + id)
        }
      })

      this.props.leftSidebar.close()
    }
  }

  render () {
    const {
      name
    } = this.props

    return (
      <CardModalView
        title={<FormattedMessage id='CARD_CREATE_HEADER' />}
      >
        <ViewBody>
          <CreateTemplateAction
            validate={this.handleValidate}
            onSubmit={this.handleSubmit}
            initialValues={{
              name
            }}
          />
        </ViewBody>
      </CardModalView>
    )
  }
}

export default injectIntl(withLeftSidebar(CreateCard))
